import React, { useRef, useEffect, useMemo } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import Colors from "../../../../Resources/Color";
import { getScrollableNodeFromRef } from "../utils/floatingUtils";

/**
 * Recently Used Row component
 */
export const RecentlyUsedRow = ({
  exercise,
  isSelected,
  onSelect,
  onHover,
  t,
  language,
  index,
  totalResults,
  scrollContainerRef,
  keyboardNavigationRef,
}) => {
  const rowRef = useRef(null);

  // Build the full exercise name
  const fullName = useMemo(() => {
    return exercise.getName(t, language);
  }, [exercise, t, language]);

  // Scroll into view when selected
  useEffect(() => {
    if (
      isSelected &&
      keyboardNavigationRef?.current &&
      rowRef.current &&
      scrollContainerRef?.current
    ) {
      const isFirstItem = index === 0;
      const isLastItem = index === totalResults - 1;
      const rowElement = rowRef.current;

      const scrollContainer = getScrollableNodeFromRef(scrollContainerRef);

      if (isFirstItem) {
        scrollContainerRef.current?.scrollTo?.({ y: 0, animated: true });
        if (scrollContainer) {
          scrollContainer.scrollTop = 0;
        }
        return;
      }

      if (isLastItem) {
        scrollContainerRef.current?.scrollToEnd?.({ animated: true });
        if (scrollContainer) {
          const containerHeight = scrollContainer.clientHeight;
          const scrollHeight = scrollContainer.scrollHeight;
          scrollContainer.scrollTop = scrollHeight - containerHeight;
        }
        return;
      }

      rowElement.scrollIntoView?.({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [
    isSelected,
    index,
    totalResults,
    scrollContainerRef,
    keyboardNavigationRef,
  ]);

  return (
    <TouchableOpacity
      ref={rowRef}
      onPress={onSelect}
      onMouseEnter={onHover}
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingVertical: 10,
        paddingHorizontal: 12,
        marginHorizontal: 8,
        borderRadius: 10,
        backgroundColor: isSelected
          ? "rgba(63, 123, 141, 0.08)"
          : "transparent",
        outlineStyle: "none",
      }}
    >
      {/* Left: Exercise name */}
      <View
        style={{
          flexGrow: 1,
          flexShrink: 1,
          marginRight: 10,
          minWidth: 0,
        }}
      >
        <Text style={{ fontSize: 13, color: Colors.blackColor }}>
          {fullName}
        </Text>
      </View>

      {/* Right: Clock icon to indicate recently used */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 6,
        }}
      >
        <Ionicons name="time-outline" size={14} color={Colors.grayColor} />
      </View>
    </TouchableOpacity>
  );
};
